import { combineReducers } from "redux"
import loading from './loader'
import list from './list'
import current from './current'
import questions from './questions'
import statistic from "./statistic"
import can_try from "./try"
import files from "./files"
import token from "./token"


const testing = combineReducers({
  list,
  current,
  can_try,
  questions,
  statistic,
  token,
  loading,
  files
})



export default testing